class stringHelper {
  static getContentLength (str) {
    let len = 0
    for (let i = 0; i < str.length; i++) {
      if (escape(str.charAt(i)).length === 6) {
        len++
      }

      len++
    }

    return len
  }

  static limitString (str, limitChar) {
    if (str) {
      if (str.length > limitChar) {
        return `${str.substring(0, limitChar)  }...`
      }
    }
    return str
  }

  static getFirstInitial (value) {
    return value.substring(0, 1)
  }

  static toUpperCase (value) {
    return value.toUpperCase()
  }

  static toUpperCaseFirst (value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }

  static jsonEncode (value) {
    return JSON.parse(value)
  }

  static contentIsMobile (number) {
    return number !== null && number.substring(0, 2) === '01'
  }
}

export default stringHelper
